export default __webpack_public_path__ + "static/media/18.5cbb8c3e.jpg";